<template>
  <div class="container print-resident">
    <b-overlay :show="loading" opacity="0.99">
      <ErrorsMessages :errors="errors" />
      <div v-show="errors.length == 0">
        <div
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 content-btn-print d-flex justify-content-end"
        >
          <v-btn class="btn-print" v-on:click="printOut"
            ><i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR</v-btn
          >
        </div>
        <table class="bg-white">
          <thead>
            <div v-if="resident.id" class="row">
              <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 pt-1 pb-0">
                <img
                  v-if="rest_home_logo_url"
                  class="rest_home_logo_url"
                  :src="rest_home_logo_url"
                />
                <div v-if="!rest_home_logo_url" class="ml-1">
                  <strong class="text-uppercase">{{ rest_home_name }}</strong>
                </div>
              </div>
              <div class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-7 pt-1 pb-0">
                <div class="row">
                  <img
                    v-if="resident.photo_url"
                    class="resident_photo_url"
                    :src="resident.photo_url"
                  />
                  <img
                    v-if="!resident.photo_url"
                    class="resident_photo_url"
                    :src="require('../../assets/user.png')"
                  />
                  <div class="ml-5 mt-2">
                    <h6 class="mb-0">
                      {{ resident.name }}
                    </h6>
                    <h6 class="mb-0 worksansr upper-text">
                      Data de nascimento:
                      {{ formatDate(resident.date_of_birth, false) }}
                      -
                      {{ getAge(resident.date_of_birth) }}
                      anos
                    </h6>
                    <h6 class="mb-0 worksansr upper-text">
                      Data de admissão:
                      {{ formatDate(resident.date_of_reception, false) }}
                    </h6>
                  </div>
                </div>
              </div>
              <div
                class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 pt-1 pb-0 check-text-right"
              >
                <img class="logo" :src="logo" width="180" />
              </div>
            </div>
          </thead>
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="row data-inside-avoid">
              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0 text-center border"
              >
                <h6 class="mb-0">INFORMAÇÕES</h6>
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>NOME:</strong> {{ resident.name }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>GÊNERO:</strong>
                {{ resident.gender_name }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>DATA DE NASCIMENTO:</strong>
                {{ formatDate(resident.date_of_birth, false) }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>STATUS:</strong>
                {{ resident.status_type_name }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>APELIDO:</strong>
                {{ resident.nickname }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>GRAU DE DEPENDÊNCIA:</strong>
                {{ resident.degree_of_dependence_name }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>PATOLOGIA (DOENÇA):</strong>
                {{ resident.pathology }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>ALERGIAS DIVERSAS:</strong>
                {{ resident.miscellaneous_allergies }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>TIPO DE ALIMENTAÇÃO:</strong>
                {{ resident.type_of_food }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>NATURALIDADE:</strong>
                {{ resident.naturalness }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>ESTADO CIVIL:</strong>
                {{ resident.marital_status && resident.marital_status.name }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>RELIGIÃO:</strong>
                {{ resident.religion }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>PROFISSÃO:</strong>
                {{ resident.profession }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>ESCOLARIDADE:</strong>
                {{ resident.schooling }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>NOME DO PAI:</strong>
                {{ resident.fathers_name }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>NOME DA MÃE:</strong>
                {{ resident.mothers_name }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>CÔNJUGE:</strong>
                {{ resident.spouse }}
              </div>
              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>OBSERVAÇÕES:</strong>
                {{ resident.comments }}
              </div>
            </div>
            <div class="row data-inside-avoid">
              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0 text-center border"
              >
                <h6 class="mb-0">DOCUMENTOS</h6>
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>CPF:</strong>
                {{ resident.cpf }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>RG:</strong>
                {{ resident.rg }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>ORGÃO EXPEDIDOR:</strong>
                {{ resident.issuing_body }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>DATA DE EMISSÃO:</strong>
                {{ resident.rg }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>NÚMERO DO CARTÃO SUS:</strong>
                {{ resident.SUS_card_number }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>NÚMERO DO BENEFÍCIO DO INSS:</strong>
                {{ resident.INSS_benefit_number }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>TIPO DE BENEFÍCIO INSS:</strong>
                {{ resident.type_of_INSS_benefit }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>SITUAÇÃO DO BENEFÍCIO DO INSS:</strong>
                {{ resident.INSS_benefit_status }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>VALOR DO BENEFÍCIO DO INSS:</strong>
                {{ formatPrice(resident.INSS_benefit_amount) }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>DATA DA ATUALIZAÇÃO DO INSS:</strong>
                {{ formatDate(resident.INSS_update_date, false) }}
              </div>
            </div>
            <div class="row data-inside-avoid">
              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0 text-center border"
              >
                <h6 class="mb-0">ENDEREÇO</h6>
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>CEP:</strong>
                {{ resident.cep }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>ENDEREÇO:</strong>
                {{ resident.address }}, {{ resident.number_address }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>BAIRRO:</strong>
                {{ resident.neighborhood }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>CIDADE:</strong>
                {{ resident.city }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>ESTADO:</strong>
                {{ resident.uf && resident.uf.name }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>REFERÊNCIA:</strong>
                {{ resident.reference }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>COMPLEMENTO:</strong>
                {{ resident.complement }}
              </div>
            </div>
            <div class="row data-inside-avoid">
              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0 text-center border"
              >
                <h6 class="mb-0">HOSPEDAGEM</h6>
              </div>
              <div
                v-if="resident.type_of_hosting"
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                {{ resident.type_of_hosting.billing_type_of_hosting_type_name }}
                {{ resident.type_of_hosting.name }}
                <strong>- Valor da mensalidade:</strong>
                {{ formatPrice(resident.income_monthly_fee) }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>DATA DA HOSPEDAGEM:</strong>
                {{ formatDate(resident.date_of_reception, false) }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong class="mr-2">LEITO DO RESIDENTE:</strong>
                <span>
                  <strong>Número:</strong>
                  {{ resident.bed && resident.bed.number }}
                </span>
                <strong class="mr-2">-</strong>
                <span>
                  <strong>Andar:</strong>
                  {{ resident.bed && resident.bed.walk }}
                </span>
                <strong class="mr-2">-</strong>
                <span>
                  <strong>Ala/setor:</strong>
                  {{ resident.bed && resident.bed.ward_or_sector }}
                </span>
                <strong class="mr-2">-</strong>
                <span>
                  <strong>Quarto:</strong>
                  {{ resident.bed && resident.bed.bedroom }}
                </span>
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>MOTIVO DA HOSPEDAGEM:</strong>
                {{ resident.reason_for_the_reception }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>DATA DO ENCERRAMENTO DO CONTRATO:</strong>
                {{ formatDate(resident.date_of_the_withdrawal, false) }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>MOTIVO DO ENCERRAMENTO DO CONTRATO:</strong>
                {{ resident.reason_for_the_withdrawal }}
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 upper-text worksansr"
              >
                <strong>OUTROS MOTIVOS:</strong>
                {{ resident.other_reasons }}
              </div>
            </div>
            <div
              v-if="
                resident.customer_has_resident &&
                resident.customer_has_resident.length > 0
              "
              class="row data-inside-avoid"
            >
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pt-0 pb-0 text-center border"
              >
                <h6 class="mb-0">FAMILIARES VINCULADOS</h6>
              </div>
              <div
                class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12 pt-0 pb-0 text-center border"
              >
                <h6 class="mb-0">RESPONSÁVEL FINANCEIRO</h6>
              </div>
              <div
                class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12 pt-0 pb-0 text-center border"
              >
                <h6 class="mb-0">SACADOR AVALISTA</h6>
              </div>

              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                v-for="(item, key) in resident.customer_has_resident"
                :key="key"
              >
                <div class="row">
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="pt-0 pb-0 upper-text worksansr">
                      <strong>NOME:</strong> {{ item.name }}
                    </div>
                    <div class="pt-0 pb-0 upper-text worksansr">
                      <strong>E-MAIL:</strong> {{ item.email }}
                    </div>
                    <div class="pt-0 pb-0 upper-text worksansr">
                      <strong>GRAU DE PARENTESTO:</strong>
                      {{ item.type_of_customer_name }}
                    </div>
                    <div class="pt-0 pb-0 upper-text worksansr">
                      <strong>1º TELEFONE:</strong> {{ item.first_phone }}
                    </div>
                    <div class="pt-0 pb-0 upper-text worksansr">
                      <strong>2º TELEFONE:</strong> {{ item.second_phone }}
                    </div>
                  </div>
                  <div
                    class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12 text-center"
                  >
                    {{ item.responsible_for_payment ? "SIM" : "NÃO" }}
                  </div>
                  <div
                    class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12 text-center"
                  >
                    {{ item.guarantor == "SIM" ? "SIM" : "NÃO" }}
                  </div>
                </div>
                <hr class="m-0" />
              </div>

              <div
                v-if="resident.agreement && resident.agreement.length > 0"
                class="row m-0 data-inside-avoid"
              >
                <div class="col-md-12 pt-0 pb-0 text-center border">
                  <h6 class="mb-0">CONVÊNIOS</h6>
                </div>

                <div
                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                  v-for="(item, key) in resident.agreement"
                  :key="key"
                >
                  <div class="row">
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                      <div class="pt-0 pb-0 upper-text worksansr">
                        <strong>NOME:</strong> {{ item.covenant_name }}
                      </div>
                      <div class="pt-0 pb-0 upper-text worksansr">
                        <strong>TIPO/NOME DO PLANO:</strong>
                        {{ item.type_plan_name }}
                      </div>
                      <div class="pt-0 pb-0 upper-text worksansr">
                        <strong>NOME DO TITULAR:</strong>
                        {{ item.name }}
                      </div>
                      <div class="pt-0 pb-0 upper-text worksansr">
                        <strong>TELEFONE DA CENTRAL:</strong>
                        {{ item.exchange_phone }}
                      </div>
                      <div class="pt-0 pb-0 upper-text worksansr">
                        <strong>TELEFONE:</strong> {{ item.phone }}
                      </div>
                      <div class="pt-0 pb-0 upper-text worksansr">
                        <strong>CELULAR:</strong> {{ item.cell_phone }}
                      </div>
                      <div class="pt-0 pb-0 upper-text worksansr">
                        <strong>OBSERVAÇÕES:</strong> {{ item.note }}
                      </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                      <div class="pt-0 pb-0 upper-text worksansr">
                        <strong>CEP:</strong>
                        {{ item.cep }}
                      </div>
                      <div class="pt-0 pb-0 upper-text worksansr">
                        <strong>ENDEREÇO:</strong>
                        {{ item.address }}, {{ item.number_address }}
                      </div>
                      <div class="pt-0 pb-0 upper-text worksansr">
                        <strong>BAIRRO:</strong>
                        {{ item.neighborhood }}
                      </div>
                      <div class="pt-0 pb-0 upper-text worksansr">
                        <strong>CIDADE:</strong>
                        {{ item.city }}
                      </div>
                      <div class="pt-0 pb-0 upper-text worksansr">
                        <strong>ESTADO:</strong>
                        {{ item.uf }}
                      </div>
                      <div class="pt-0 pb-0 upper-text worksansr">
                        <strong>REFERÊNCIA:</strong>
                        {{ item.reference }}
                      </div>
                      <div class="pt-0 pb-0 upper-text worksansr">
                        <strong>COMPLEMENTO:</strong>
                        {{ item.complement }}
                      </div>
                    </div>
                  </div>
                  <hr class="m-0" />
                </div>
              </div>
            </div>
            <div class="text-center">
              (Assinatura eletrônica)
              {{
                professionalClassCouncilValue({
                  id: user.professional_class_council_id,
                  name: user.name,
                  profile: user.profile_name,
                  cpf: user.cpf,
                  office: user.office,
                  value: user.professional_class_council_value,
                })
              }}
              <small> - {{ moment().format("DD/MM/YYYY HH:mm:ss") }} </small>
            </div>
          </div>
        </table>
        <div
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 content-btn-print d-flex justify-content-end"
        >
          <v-btn class="btn-print" v-on:click="printOut"
            ><i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR</v-btn
          >
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages";

import api from "../../services/api";

import { getAge } from "../../lib/getAgeByDate";

import {
  formatDate,
  formatPrice,
  professionalClassCouncilValue,
} from "../../lib/format";

import routes from "../../routes";

import moment from "moment";

import { userData } from "../../lib/functions";

export default {
  name: "PrintResident",
  components: {
    ErrorsMessages,
  },
  data() {
    return {
      id: "",
      errors: [],
      rest_home_id: "",
      user: {},
      resident: {},
      rest_home_name: "",
      rest_home_fantasy_name: "",
      rest_home_logo_url: null,
      logo: null,
      loading: true,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    moment,
    getAge,
    formatDate,
    formatPrice,
    professionalClassCouncilValue,
    async retrieve() {
      const { id } = routes.history.current.params;

      this.id = id;

      const { rest_home_id, user, logo, permissions } = userData();

      this.user = user;
      this.rest_home_id = rest_home_id;
      this.rest_home_name = user.rest_home_name;
      this.rest_home_fantasy_name = user.rest_home_fantasy_name;
      this.rest_home_logo_url = user.logo_url;
      this.logo = logo;

      this.permissions = permissions;

      await this.get();
    },
    async get() {
      try {
        this.loading = true;

        const { id } = this;

        var params = { id };

        const response = await api.get("/rest-home/resident/print", {
          params,
        });

        const { error, errors, resident } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.resident = resident;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    printOut: () => window.print(),
  },
};
</script>

<style>
.print-resident table {
  width: 100%;
}

.print-resident .header {
  position: fixed;
  top: 0;
}

.print-resident .logo {
  height: 50px;
  object-fit: contain;
}

.print-resident .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}

.print-resident .resident_photo_url {
  height: 80px;
  width: 80px;
  border-radius: 50%;
  object-fit: cover;
}

@media print {
  .print-resident table {
    width: 100% !important;
  }

  .print-resident button {
    display: none;
  }

  .print-resident .content {
    page-break-inside: avoid !important;
  }

  .print-resident .data-inside-avoid {
    page-break-inside: avoid !important;
  }

  .print-resident .finish_user {
    font-size: small !important;
  }
}
</style>
